
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/latihan/session",
      function () {
        return require("private-next-pages/latihan/session/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/latihan/session"])
      });
    }
  